import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import HelpIcon from './HelpIcon';

let Quote = require('../Managers/Quote');
let Validation = require('../Managers/Validation.js');

const TextInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        maxLength:     React.PropTypes.number.isRequired,
        loadCachedValue: React.PropTypes.bool,
        hasBorder: React.PropTypes.bool,
        supplementaryId:   React.PropTypes.string,
    },

    getDefaultProps() {
        return {
            length: 50,
            hasBorder: true,
        };
    },

    getInitialState() {
        return {
            activeValue: Quote.getCurrentAnswer(this.props.fieldName)?Quote.getCurrentAnswer(this.props.fieldName):localStorage.getItem(this.props.fieldName),
            isHelpVisible: false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
             hasError: false,
            errors: null,
        };
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    doValidation() {

        if(this.props.fieldName == "first_name"){
            let validation = Validation.validate(this.props.fieldName, $('#first_name').val())[0];
            this.setState(validation);
            if (validation.isValid) {
                this.setState({
                    activeValue: $('#first_name').val(),
                    isValid: true
                });
                Quote.set(this.props.fieldName, $('#first_name').val());
                localStorage.setItem("first_name",$('#first_name').val());
            } else {
                Quote.set(this.props.fieldName, "");
            }
        }
        if(this.props.fieldName == "last_name"){
            let validation = Validation.validate(this.props.fieldName, $('#last_name').val())[0];
            this.setState(validation);
            if (validation.isValid) {
                this.setState({
                    activeValue: $('#last_name').val(),
                    isValid: true
                });
                Quote.set(this.props.fieldName, $('#last_name').val());
                localStorage.setItem("last_name",$('#last_name').val());
            } else {
                Quote.set(this.props.fieldName, "");
            }
        }
        

        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    setActiveValue(event) {
        let validation = Validation.validate(this.props.fieldName, event.target.value)[0];
        this.setState(validation);
        if (validation.isValid) {
            this.setState({
                activeValue: event.target.value,
                isValid: true
            });
            Quote.set(this.props.fieldName, event.target.value);
        } else {
            Quote.set(this.props.fieldName, "");
        }
    },


    render() {
        return (
            <div>
                <question-row class={this.props.hasBorder === false ? 'no-border' : null}>
                    <div className="question-main">
                        <div className="question-top">
                            <label>{this.props.question}</label>
                            {this.props.helpText ?  <HelpIcon onClick={this.toggleHelpText} /> : null }
                        </div>
                        <div className="question-input">
                            <input
                                name={this.props.fieldName}
                                id={this.props.fieldName}
                                type="text"
                                className="form-control"
                                maxLength={this.props.maxLength}
                                onBlur={this.setActiveValue}
                                defaultValue={this.state.activeValue}
                            />

                            {this.state.isHelpVisible ? (
                                <div className="hint-container">
                                    <div className="hint">
                                        <div className="arrow arrow-left" />
                                        {this.props.helpText}
                                    </div>
                                </div>
                            ) : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                </question-row>
            </div>
        );
    }
});

export default TextInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/TextInput.js
 **/